import { useState, useEffect, useContext } from "react";
import { leftBoxContext } from "../Frameleft.js";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { link } from "../../../../config.js";
import { useAddress } from "../../AddressContext.jsx";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const Name_REGEX = /^[A-Za-z ]*$/; //reg for name which contain space and charachters only
const ANY_Name_REGEX = /^.*$/; //reg for name which contain any character
const Phone_REGEX = /^\d*$/; //reg for name which contain numbers

function Frame420() {
  const { selectedAddress, setSelectedAddress } = useAddress();

  // const [email, setEmail] = useState('')
  // const [ismailFocuss, setIsEmailFocus] = useState(false)
  // const [validMail, setValidMail] = useState(false)
  const { t } = useTranslation();

  // const [name, setName] = useState('')
  const { name, setName } = useContext(leftBoxContext);
  const [isnameFocus, setIsnameFocus] = useState(false);
  const [validName, setValidName] = useState(false);

  // const [phone, setPhone] = useState('')
  const { phone, setPhone } = useContext(leftBoxContext);
  const [isPhoneFocus, setIsPhoneFocus] = useState(false);
  const [validPhone, setValidPhone] = useState(false);

  // const [city, setCity] = useState('')
  const { city, setCity } = useContext(leftBoxContext);
  const [isCityFocus, setIsCityFocus] = useState(false);
  const [validCity, setValidCity] = useState(false);

  // const [area, setArea] = useState('')
  const { area, setArea } = useContext(leftBoxContext);
  const [isAreaFocus, setIsAreaFocus] = useState(false);
  const [validArea, setValidArea] = useState(false);

  // const [address, setAddress] = useState('')

  const { address, setAddress } = useContext(leftBoxContext);
  const [isAddressFocus, setIsAdrressFocus] = useState(false);
  const [validAddress, setValidAddress] = useState(false);

  // const [house, setHouse] = useState('')
  const { house, setHouse } = useContext(leftBoxContext);
  const [isHouseFocus, setIsHouseFocus] = useState(false);
  const [validHouse, setValidHouse] = useState(false);

  const [showDropdwon, setShowDropdown] = useState(false);

  const [countries, setCountries] = useState([]);
  const [areas, setAreas] = useState([]);
  // const [phoneType, setPhoneType] = useState(<> <img src={EgyptIcon} className='egypt' /> <span>+20</span></>);

  // useEffect(() => {
  //   setValidMail(EMAIL_REGEX.test(email));
  // }, [email])

  const getCountries = async () => {
    const { data } = await axios.get(`${link}countries-areas`);
    setCountries(data.data);
  };
  const getAreas = async (id) => {
    const { data } = await axios.get(
      `${link}areas-flat/by-country?countryId=${id}`
    );
    setAreas(data.data);
  };
  useEffect(() => {
    setValidName(Name_REGEX.test(name));
    setValidCity(Name_REGEX.test(city));
    getCountries();
  }, [name, city]);
  useEffect(() => {
    setValidPhone(Phone_REGEX.test(phone));
  }, [phone]);

  useEffect(() => {
    setValidArea(ANY_Name_REGEX.test(area));
    setValidAddress(ANY_Name_REGEX.test(address));
    setValidHouse(ANY_Name_REGEX.test(house));
  }, [area, address, house]);

  const handleName = (e) => {
    if (Name_REGEX.test(e)) setName(e);
  };
  const handlePhone = (e) => {
    if (Phone_REGEX.test(e)) setPhone(e);
  };

  // const choosePhoneType = (src, text) => {
  //   setShowDropdown(false)
  //   // setPhoneType(<><img src={src} className='egypt' /> <span>{text}</span></>)
  // }
  const handleAreaChange = (e) => {
    const selectedArea = e.target.value;

    // Update the selectedAddress context
    // setSelectedAddress((prevAddress) => ({
    //   ...prevAddress,
    //   area: selectedArea,
    // }));

    // Update the area state
    setArea(selectedArea);
  };
  return (
    <form>
      <div className="frame-420">
        {/* <div>
        <label>Email
          <span className={ismailFocuss && !validMail ? 'text-danger' : 'text-black'}>*</span>
        </label>
        <input type="email"
          name='email'
          value={email}
          required
          onChange={(e) => { setEmail(e.target.value) }}
          onFocus={() => setIsEmailFocus(true)}
          placeholder="Please enter a valid email  " />
      </div> */}
        <div className="gap-2 d-flex flex-column flex-lg-row juctify-content-between ">
          <div className="d-flex flex-column flex-grow-1">
            <label>
              {t("Full Name")}
              <span
                className={
                  isnameFocus && !validName ? "text-danger" : "text-black"
                }
              >
                *
              </span>
            </label>
            <input
              type="text"
              name="name"
              value={name}
              required
              onChange={(e) => {
                handleName(e.target.value);
              }}
              onFocus={() => setIsnameFocus(true)}
              placeholder={t("addFullName")}
            />
          </div>
          <div className="d-flex flex-column flex-grow-1">
            <label>
              {t("Mobile number")}
              <span
                className={
                  isPhoneFocus && !validPhone ? "text-danger" : "text-black"
                }
              >
                *
              </span>
            </label>
            <input
              type="text"
              name="phone"
              value={phone}
              required
              onChange={(e) => {
                handlePhone(e.target.value);
              }}
              onFocus={() => setIsPhoneFocus(true)}
              placeholder={t("addMobileNumber")}
            />
          </div>
        </div>
        <div className="d-flex flex-column flex-lg-row juctify-content-between gap-2">
          <div className="d-flex flex-column flex-grow-1">
            <label>
              {t("city")}
              <span
                className={
                  isCityFocus && !validCity ? "text-danger" : "text-black"
                }
              >
                *
              </span>
            </label>
            <select
              name="city"
              value={city}
              required
              onChange={(e) => {
                const selectedCountryName = e.target.value; // Get the selected country name
                const selectedCountry = countries.find(
                  (country) => country.name === selectedCountryName
                ); // Find the selected country object
                setCity(selectedCountryName); // Update the city state with the country name
                getAreas(selectedCountry._id); // Fetch areas based on the selected country ID
              }}
              onFocus={() => setIsCityFocus(true)}
            >
              <option value="">{t("addCity")}</option>
              {countries.map((country) => (
                <option key={country._id} value={country.name}>
                  {country.name}
                </option>
              ))}
            </select>
          </div>
          <div className="d-flex flex-column flex-grow-1">
            <label>
              {t("area")}
              <span
                className={
                  isAreaFocus && !validArea ? "text-danger" : "text-black"
                }
              >
                *
              </span>
            </label>
            <select
              name="area"
              value={area}
              required
              onChange={handleAreaChange}
              onFocus={() => setIsAreaFocus(true)}
            >
              <option value="">{t("addArea")}</option>
              {areas.map((area) => (
                <option key={area._id} value={area.name}>
                  {area.name}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div>
          <label>
            {t("address")}
            <span
              className={
                isAddressFocus && !validAddress ? "text-danger" : "text-black"
              }
            >
              *
            </span>
          </label>
          <input
            type="text"
            name="address"
            value={address}
            required
            onChange={(e) => {
              setAddress(e.target.value);
            }}
            onFocus={() => setIsAdrressFocus(true)}
            placeholder={t("addAddress")}
          />
        </div>
        <div className="house d-flex flex-column">
          <label>
            {t("house")}
            <span
              className={
                isHouseFocus && !validHouse ? "text-danger" : "text-black"
              }
            >
              *
            </span>
          </label>
          <input
            type="text"
            name="house"
            value={house}
            required
            onChange={(e) => {
              setHouse(e.target.value);
            }}
            onFocus={() => setIsHouseFocus(true)}
            placeholder={t("addHouseNumber")}
          />
        </div>
      </div>
    </form>
  );
}
export default Frame420;
